import { CommonModule } from '@angular/common';
import { Component, NgModule, OnInit, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { TranslateService } from '@codeandweb/ngx-translate';

import { Table, TableModule } from '@app/primeng-overrides/table';
import { LazyLoadEvent } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { ToolbarModule } from 'primeng/toolbar';

import { GlobalModule } from '@app/_global/global.module';
import { AbonneService } from '@app/abonne/abonne.service';
import { environment } from '@environments/environment';
import { EventManagerService, IEventListener } from '@global/event-manager.service';
import { NomenclatureService } from '../nomenclature.service';
import { HistoriqueElementNomenclature } from '../nomenclature.model';

import { uid } from '@helpers/utils';

@Component({
	selector: 'nomenclature-historique-dialog',
	templateUrl: './historique-dialog.html',
	providers: []
})
export class HistoriqueNomenclatureDialogComponent implements OnInit, IEventListener {

	private _uuid: string = uid();
	get uuid(): string { return this._uuid; }

	@ViewChild('tableHistorique', { static: true }) table: Table;

	values: HistoriqueElementNomenclature[] = [];
	totalRecords: number = 0;
	loading: boolean;
	rows: number = environment.default_rows;

	search: string | null = null;

	constructor(
		private config: DynamicDialogConfig,
		private dialogRef: DynamicDialogRef,
		private eventManager: EventManagerService,
		private translateService: TranslateService,
		private nomenclatureService: NomenclatureService,
	) {

	}

	ngOnInit(): void {
		this.eventManager.registerEvent('close-modals', this, (args: any) => this.dialogRef.close());
	}


	ngOnDestroy(): void {
		this.eventManager.unregisterEvent('close-modals', this);
	}


	loadHistorique(event: LazyLoadEvent) {
		// https://github.com/primefaces/primeng/issues/8465#issuecomment-617887919
		Promise.resolve(null).then(() => {
			this.loading = true;
		});

		const tmpParams = Object.assign({}, event, {search: this.search});

		this.nomenclatureService
			.getHistoriqueNomenclature()
			.subscribe({
				next: ({ total, historique }) => {
					this.totalRecords = total;
					this.values = historique;

					// si on revient sur la liste paginée et que la page en question est vide, on reset
					if (this.values.length === 0 && this.table.first != 0) {
						this.refresh();
					}
				}
			})
			.add(() => {
				this.loading = false;
			});
	}

	resetSearch() {
		this.search = null;
	}

	refresh(stayOnPage?: boolean) {
		if (!stayOnPage) this.table._first = 0;
		this.table.onLazyLoad.emit(this.table.createLazyLoadMetadata());
	}

}


@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		GlobalModule,
		ButtonModule,
		InputTextareaModule,
		TableModule,
		ToolbarModule
	],
	exports: [HistoriqueNomenclatureDialogComponent],
	declarations: [HistoriqueNomenclatureDialogComponent]
})
export class HistoriqueNomenclatureDialogModule { }

